import React, { useEffect, useRef, useState } from "react";
import { FormObjectService } from "../../core/FieldObject";
import {
  DocuTypeObj,
  DocuTypeService,
} from "../../model/backoffice/document-type";
import { useDispatch, useSelector } from "react-redux";
import { GetEditorForm } from "../../core/Helper2";
import FormAutoObject from "../../core/FormAutoObject";
import { AlertOK } from "../../core/Helper";

export default function DocutypeEditor(props) {
  const [editor, setEditor] = props?.editor;

  const [objField, setObjField] = useState([]);
  const [form, setForm] = useState(null); //** Form objects */
  const [data, setData] = useState([]); //** Form data */
  const refForm1 = useRef();
  const userInfo = useSelector((state) => state.user.detail);
  const dispatch = useDispatch();

  /**Form init*/
  useEffect(() => {
    if (editor?.show) {
      console.log("Test Editor..", editor);
      buildForm();
      if (editor?.idValue > 0) {
        getOldData();
      }
    }
    return () => {
      setData([]);
    };
  }, [editor?.show]);

  /** Build Form objects */
  const buildForm = async () => {
    // setObjField(await FormObjectService.BuildsFormOBJs(new DocuType()));
    setObjField(await FormObjectService.BuildsFormOBJs(DocuTypeObj));
  };

  const getOldData = async () => {
    console.log("Getting old data");
    let ret = await DocuTypeService.GetItem(
      { [editor.idFieldName]: editor.idValue },
      userInfo
    );
    if (ret) {
      //console.log(ret);
      setData(ret);
    } else {
      //console.log("Data Not Found!");
    }
  };

  /** Render form */
  const renderForm = async () => {
    setForm(
      <FormAutoObject
        {...{ items: objField, dataValue: [data, setData], refTo: refForm1 }}
      />
    );
  };

  /** SAVE */
  const actionSave = async () => {
    let fData1 = {
      ...Object.fromEntries(new FormData(refForm1.current)),
      [editor.idFieldName]: editor.idValue,
    };
    //include selector options
    fData1 = FormObjectService.IncludeSelectorKeyField(fData1, objField);
    //change "on" to true
    FormObjectService.ConvertSwitchON2Boolean(fData1);
    let ret = await DocuTypeService.SaveItem(fData1, userInfo);
    if (ret != null) {
      AlertOK("Save OK", dispatch);
      editor.action();
      setEditor({ show: false });
    }
  };

  /** Build Form */
  useEffect(() => {
    renderForm();
  }, [objField, data]);

  return (
    <div>
      <GetEditorForm
        {...{
          editor: [editor, setEditor],
          form: [form, setForm],
          saveData: actionSave,
        }}
      />
    </div>
  );
}
